import React, { Component } from 'react'
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import Icons from '~/Common-Objects/UI/Icons/index'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import { connect } from 'react-redux'
import thestore from '~/data/store/store'

import ComponentText from './text'
import ComponentSelect from './select'
import ArraySelect from './arraySelect'
import i18n from '~/i18n'
@connect((store) => {
    return { user: store.user }
})
export default class PollPicker extends Component {
    constructor(props) {
        super(props)

        this.state = {
            questionTypeOrder: [
                'question',
                'description',
                'answers',
                'allowMulti',
                'button',
                'link',
                'shape',
                'color',
                'showLabels',
                'positiveLabel',
                'inputType',
                'negativeLabel',
                'showPlaceHolder',
                'placeHolder'
            ],
            questionTypes: [
                {
                    label: i18n.t('templates:add.drag.polls.intro'),
                    value: 'intro',
                    question: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.introDefaultQ')
                    },
                    description: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.introDefaultDesc')
                    },
                    rules: [],
                    button: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.introDefaultButton')
                    }
                },
                {
                    label: i18n.t('templates:add.drag.polls.satisfactionScore'),
                    value: 'satisfaction',
                    question: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.satisfactionScoreQ')
                    },
                    description: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    rules: [],
                    shape: {
                        editable: true,
                        editableType: 'select',
                        values: ['smiley', 'star'],
                        value: 'smiley'
                    },
                    color: {
                        editable: true,
                        editableType: 'select',
                        values: ['colorful', 'mono'],
                        value: 'colorful'
                    },
                    negativeLabel: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    positiveLabel: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    }
                },
                {
                    label: i18n.t('templates:add.drag.polls.promoterScore'),
                    value: 'promoter',
                    question: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.promoterScoreQ')
                    },
                    description: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    rules: [],
                    negativeLabel: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    positiveLabel: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    }
                },
                {
                    label: i18n.t('templates:add.drag.polls.multipleChoice'),
                    value: 'multiple',
                    question: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.multipleChoiceQ')
                    },
                    description: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    rules: [],
                    answers: {
                        editable: true,
                        editableType: 'arraySelect',
                        value: [
                            {
                                label: i18n.t('templates:add.drag.polls.multipleChoiceA1'),
                                value: i18n.t('templates:add.drag.polls.multipleChoiceA1')
                            },
                            {
                                label: i18n.t('templates:add.drag.polls.multipleChoiceA2'),
                                value: i18n.t('templates:add.drag.polls.multipleChoiceA2')
                            }
                        ]
                    },

                    allowMulti: {
                        editable: true,
                        editableType: 'select',
                        value: false,
                        values: [
                            { label: i18n.t('templates:add.drag.polls.yes'), value: true },
                            { label: i18n.t('templates:add.drag.polls.no'), value: false }
                        ]
                    }
                },
                {
                    label: i18n.t('templates:add.drag.polls.question'),
                    value: 'question',
                    question: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.questionQ')
                    },
                    description: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    rules: [],
                    inputType: {
                        editable: true,
                        editableType: 'select',
                        value: false,
                        values: [
                            { label: i18n.t('templates:add.drag.polls.questionT1'), value: 'text' },
                            { label: i18n.t('templates:add.drag.polls.questionT2'), value: 'textarea' }
                        ]
                    },
                    showPlaceHolder: {
                        editable: true,
                        editableType: 'select',
                        value: false,
                        values: [
                            { label: i18n.t('templates:add.drag.polls.yes'), value: true },
                            { label: i18n.t('templates:add.drag.polls.no'), value: false }
                        ]
                    },
                    placeHolder: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    button: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.introDefaultButton')
                    }
                },
                {
                    label: i18n.t('templates:add.drag.polls.likeDislike'),
                    value: 'like',
                    question: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.likeDislikeQ')
                    },
                    description: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    rules: [],
                    shape: {
                        editable: true,
                        editableType: 'select',
                        values: ['thumbs', 'hearts'],
                        value: 'thumbs'
                    },
                    color: {
                        editable: true,
                        editableType: 'select',
                        values: ['colour', 'mono'],
                        value: 'colour'
                    },
                    negativeLabel: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    positiveLabel: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    }
                },
                {
                    label: i18n.t('templates:add.drag.polls.outro'),
                    value: 'outro',
                    question: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.outroQ')
                    },
                    description: {
                        editable: true,
                        editableType: 'text',
                        value: i18n.t('templates:add.drag.polls.outroQ1')
                    },
                    rules: [],
                    button: {
                        editable: true,
                        editableType: 'text',
                        value: ''
                    },
                    link: {
                        editable: true,
                        editableType: 'link',
                        value: ''
                    }
                }
            ],
            loaded: false,
            updated: new Date(),
            editQuestion: -1,
            selectedQuestion: 0,
            dragging: false,
            draggedIndex: null,
            dragOverIndex: null,
            insertPosition: 'bottom'
        }

        this.addQuestion = this.addQuestion.bind(this)
        this.changeQuestionType = this.changeQuestionType.bind(this)
        this.deleteQuestion = this.deleteQuestion.bind(this)
        this.editQuestion = this.editQuestion.bind(this)
        this.editUpdateVal = this.editUpdateVal.bind(this)
        this.highlightQuestion = this.highlightQuestion.bind(this)
        this.handleDragStart = this.handleDragStart.bind(this)
        this.handleDragOver = this.handleDragOver.bind(this)
        this.handleDrop = this.handleDrop.bind(this)
        this.handleDragEnd = this.handleDragEnd.bind(this)
        this.handleDragEnter = this.handleDragEnter.bind(this)
        this.handleDragLeave = this.handleDragLeave.bind(this)
    }

    componentDidMount() {
        this.props.updateVal('localVariables.tmpCurrentPollId', 0)
    }

    editPoll() {
        var theDrawer = <PollEditor />
        thestore.dispatch(
            siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, true, '100vw', undefined, () => {})
        )
    }

    addQuestion(value) {
        var pollQuestions = JSON.parse(JSON.stringify(this.props.localVariables.pollQuestions.value))
        var ourPos = pollQuestions.length - 1
        if (ourPos < 0) ourPos = 0
        pollQuestions.splice(ourPos, 0, this.state.questionTypes[value])
        this.setState({ selectedQuestion: ourPos, editQuestion: ourPos })
        this.props.updateVal(
            ['localVariables.pollQuestions', 'localVariables.tmpCurrentPollId'],
            [pollQuestions, ourPos]
        )
    }

    changeQuestionType(index, event) {
        var pollQuestions = JSON.parse(JSON.stringify(this.props.localVariables.pollQuestions.value))
        pollQuestions[index] = this.state.questionTypes.find((q) => q.value == event.target.value)
        this.props.updateVal('localVariables.pollQuestions', pollQuestions)
    }
    deleteQuestion(index) {
        var pollQuestions = JSON.parse(JSON.stringify(this.props.localVariables.pollQuestions.value))
        pollQuestions.splice(index, 1)
        this.setState({ selectedQuestion: -1 })
        this.props.updateVal('localVariables.pollQuestions', pollQuestions)
        // this.props.updateVal('localVariables.tmpCurrentPollId', 0)
    }
    editQuestion(index) {
        if (this.state.selectedQuestion != index) {
            this.setState({ selectedQuestion: index })
            this.props.updateVal('localVariables.tmpCurrentPollId', index)
        }
        this.setState({ editQuestion: index })
    }
    editUpdateVal(path, value) {
        var pollQuestions = JSON.parse(JSON.stringify(this.props.localVariables.pollQuestions.value))
        var pollQuestion = pollQuestions[this.state.editQuestion]
        if (!pollQuestion || !pollQuestion[path]) return
        pollQuestion[path].value = value
        this.props.updateVal('localVariables.pollQuestions', pollQuestions)
    }

    highlightQuestion(event, index) {
        if (this.state.selectedQuestion != index) {
            this.setState({ selectedQuestion: index })
            this.props.updateVal('localVariables.tmpCurrentPollId', index)
        }
    }

    handleDragStart = (index) => {
        this.setState({
            draggedIndex: index,
            dragging: true
        })
    }

    handleDragOver = (e) => {
        e.preventDefault()
        e.stopPropagation()
        e.dataTransfer.dropEffect = 'move'
    }

    handleDragEnter = (index, e) => {
        if (this.state.draggedIndex !== null && this.state.draggedIndex !== index) {
            const rect = e.currentTarget.getBoundingClientRect()
            const mouseY = e.clientY
            const elementTop = rect.top
            const elementHeight = rect.height
            const elementMiddle = elementTop + elementHeight / 2

            const insertPosition = mouseY < elementMiddle ? 'top' : 'bottom'

            this.setState({
                dragOverIndex: index,
                insertPosition: insertPosition
            })
        }
    }

    handleDragLeave = (e) => {
        const currentTarget = e.currentTarget
        const relatedTarget = e.relatedTarget

        if (!currentTarget.contains(relatedTarget)) {
            this.setState({ dragOverIndex: null })
        }
    }

    handleDrop = (e, dropIndex) => {
        e.preventDefault()
        e.stopPropagation()
        const { draggedIndex, insertPosition } = this.state

        if (draggedIndex === null || draggedIndex === dropIndex) {
            this.setState({
                draggedIndex: null,
                dragging: false,
                dragOverIndex: null,
                insertPosition: 'bottom'
            })
            return
        }

        var pollQuestions = JSON.parse(JSON.stringify(this.props.localVariables.pollQuestions.value))
        const draggedItem = pollQuestions[draggedIndex]

        pollQuestions.splice(draggedIndex, 1)

        let insertIndex
        if (insertPosition === 'top') {
            if (draggedIndex < dropIndex) {
                insertIndex = dropIndex - 1
            } else {
                insertIndex = dropIndex
            }
        } else {
            if (draggedIndex < dropIndex) {
                insertIndex = dropIndex
            } else {
                insertIndex = dropIndex + 1
            }
        }

        pollQuestions.splice(insertIndex, 0, draggedItem)

        this.props.updateVal('localVariables.pollQuestions', pollQuestions)

        const newSelectedIndex = insertIndex
        if (this.state.selectedQuestion === draggedIndex) {
            this.setState({ selectedQuestion: newSelectedIndex })
            this.props.updateVal('localVariables.tmpCurrentPollId', newSelectedIndex)
        } else if (this.state.selectedQuestion > draggedIndex && this.state.selectedQuestion <= dropIndex) {
            this.setState({ selectedQuestion: this.state.selectedQuestion - 1 })
            this.props.updateVal('localVariables.tmpCurrentPollId', this.state.selectedQuestion - 1)
        } else if (this.state.selectedQuestion < draggedIndex && this.state.selectedQuestion >= dropIndex) {
            this.setState({ selectedQuestion: this.state.selectedQuestion + 1 })
            this.props.updateVal('localVariables.tmpCurrentPollId', this.state.selectedQuestion + 1)
        }

        this.setState({
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        })
    }

    handleDragEnd = () => {
        this.setState({
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        })
    }

    render() {
        const AddQuestionSelect = (
            <ButtonSelect
                style={{ display: 'block' }}
                className='with-icon button-primary button-rounded'
                icon={<Icons icon='arrowDown' />}
                headerText='Add Section'
                filter={false}
                updateFilter={undefined}
                selectAll={undefined}
                clearAll={undefined}
                autoClose={true}
            >
                <ul>
                    {this.state.questionTypes.map((q, index) => {
                        return (
                            <li key={q.value}>
                                <a
                                    class=''
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.addQuestion(index)
                                    }}
                                    href=''
                                    role='button'
                                    style={{
                                        display: 'flex',
                                        width: '100%',
                                        overflow: 'hidden',
                                        alignItems: 'center',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {q.label}
                                </a>
                            </li>
                        )
                    })}
                </ul>
            </ButtonSelect>
        )

        if (this.state.editQuestion > -1) {
            var currQuestion = this.props.localVariables.pollQuestions.value[this.state.editQuestion]

            return (
                <div
                    style={{
                        width: 'calc(100% + 40px)',
                        position: 'absolute',
                        top: 0,
                        left: -20,
                        right: -20,
                        zIndex: 9999999,
                        backgroundColor: 'white',
                        padding: '0px 20px',
                        height: '100%'
                    }}
                >
                    <div className='panel-header panel-header--no-border'>
                        <button
                            className='button button-ghost button-sml panel-header-back button-icon-left'
                            onClick={() => {
                                this.setState({ editQuestion: -1 })
                            }}
                        >
                            <div className='button-iconLeft'>
                                <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                    className='OnTI40gySMlGByUrk68g'
                                >
                                    <path
                                        fillRule='evenodd'
                                        clipRule='evenodd'
                                        d='M9.7068 14.695C9.51927 14.8825 9.26497 14.9878 8.9998 14.9878C8.73464 14.9878 8.48033 14.8825 8.2928 14.695L4.2928 10.695C4.10533 10.5075 4.00002 10.2532 4.00002 9.98801C4.00002 9.72284 4.10533 9.46854 4.2928 9.28101L8.2928 5.28101C8.4814 5.09885 8.73401 4.99806 8.9962 5.00034C9.2584 5.00261 9.50921 5.10778 9.69462 5.29319C9.88003 5.4786 9.9852 5.72941 9.98748 5.99161C9.98975 6.25381 9.88896 6.50641 9.7068 6.69501L7.4138 8.98801H14.9998C15.265 8.98801 15.5194 9.09337 15.7069 9.2809C15.8944 9.46844 15.9998 9.72279 15.9998 9.98801C15.9998 10.2532 15.8944 10.5076 15.7069 10.6951C15.5194 10.8827 15.265 10.988 14.9998 10.988H7.4138L9.7068 13.281C9.89427 13.4685 9.99959 13.7228 9.99959 13.988C9.99959 14.2532 9.89427 14.5075 9.7068 14.695Z'
                                        fill='currentColor'
                                    ></path>
                                </svg>
                            </div>
                            Done
                        </button>
                        <h4 className='panel-header-title'>{currQuestion.label}</h4>
                    </div>

                    {this.state.questionTypeOrder.map((q, index) => {
                        var ourProp = currQuestion[q]

                        if (ourProp && ourProp.editable) {
                            let title = q[0].toUpperCase() + q.substring(1)
                            switch (ourProp.editableType) {
                                case 'text':
                                    return (
                                        <div key={'pEdit_' + index}>
                                            <ComponentText
                                                error={''}
                                                value={ourProp.value}
                                                title={title}
                                                updateVal={this.editUpdateVal}
                                                path={q}
                                                elementsData={[]}
                                                elementData={[]}
                                                selectedElement={false}
                                                localVariables={{}}
                                                updateOnChange={true}
                                            />
                                        </div>
                                    )
                                case 'link':
                                    return (
                                        <div key={'pEdit_' + index}>
                                            <ComponentText
                                                error={''}
                                                value={ourProp.value}
                                                title={title}
                                                updateVal={this.editUpdateVal}
                                                path={q}
                                                elementsData={[]}
                                                elementData={[]}
                                                selectedElement={false}
                                                localVariables={{}}
                                                inputType='link'
                                                updateOnChange={true}
                                            />
                                        </div>
                                    )
                                case 'select':
                                    return (
                                        <div key={'pEdit_' + index}>
                                            <ComponentSelect
                                                error={''}
                                                value={ourProp.value}
                                                title={title}
                                                options={ourProp.values}
                                                updateVal={this.editUpdateVal}
                                                path={q}
                                                elementData={[]}
                                                localVariables={{}}
                                            />
                                        </div>
                                    )
                                case 'arraySelect':
                                    return (
                                        <div key={'pEdit_' + index}>
                                            <ArraySelect
                                                value={ourProp.value}
                                                fieldLabelTxt={'Choice'}
                                                fieldValueTxt={'Value saved when answered'}
                                                title={title}
                                                updateVal={this.editUpdateVal}
                                                path={q}
                                                elementData={[]}
                                                localVariables={{}}
                                                valueCantBeBlank={true}
                                            />
                                        </div>
                                    )
                            }
                        }
                    })}
                </div>
            )
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <div
                    onDragOver={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                >
                    {this.props.localVariables.pollQuestions.value
                        .filter((question, index) => question.value != 'outro')
                        .map((question, index) => {
                            var style = {
                                width: '100%',
                                border: '1px solid #E1E1E0',
                                borderRadius: '8px',
                                padding: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'move',
                                backgroundColor: 'white'
                            }
                            if (this.state.selectedQuestion == index) {
                                style.border = '1px solid #15AC98'
                            }
                            if (this.state.dragging && this.state.draggedIndex === index) {
                                style.opacity = 0.5
                            }
                            const showDropLine =
                                this.state.dragging &&
                                this.state.dragOverIndex === index &&
                                this.state.draggedIndex !== index
                            const dropLineStyle = {
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                height: 2,
                                backgroundColor: '#15AC98',
                                borderRadius: 1,
                                pointerEvents: 'none',
                                zIndex: 2
                            }
                            return (
                                <div key={'PQ_' + index} className='mar-b12' style={{ position: 'relative' }}>
                                    {showDropLine && this.state.insertPosition === 'top' && (
                                        <div style={{ ...dropLineStyle, top: -7 }} />
                                    )}
                                    {showDropLine && this.state.insertPosition === 'bottom' && (
                                        <div style={{ ...dropLineStyle, bottom: -7 }} />
                                    )}
                                    <div
                                        draggable={true}
                                        onDragStart={(e) => {
                                            e.dataTransfer.effectAllowed = 'move'
                                            e.dataTransfer.setData('text/html', index.toString())
                                            e.stopPropagation()
                                            this.handleDragStart(index)
                                        }}
                                        onDragEnter={(e) => this.handleDragEnter(index, e)}
                                        onDragLeave={(e) => this.handleDragLeave(e)}
                                        onDragOver={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            e.dataTransfer.dropEffect = 'move'
                                            this.handleDragEnter(index, e)
                                        }}
                                        onDrop={(e) => {
                                            e.stopPropagation()
                                            this.handleDrop(e, index)
                                        }}
                                        onDragEnd={this.handleDragEnd}
                                        style={style}
                                        onClick={(event) => {
                                            if (!this.state.dragging) {
                                                this.highlightQuestion(event, index)
                                            }
                                        }}
                                    >
                                        <Icons
                                            icon='drag'
                                            color='#0A0A0A'
                                            style={{ marginRight: '8px', cursor: 'move', marginBottom: '-3px' }}
                                        />
                                        <div
                                            className='form-group mar-b0'
                                            style={{ flex: '1', fontWeight: '600', fontSize: '13px' }}
                                        >
                                            {question.label}
                                        </div>
                                        <div style={{ flex: '0 0', display: 'flex', alignItems: 'center' }}>
                                            <Icons
                                                icon='pencil'
                                                color='#0A0A0A'
                                                outerStyle={{
                                                    width: 24,
                                                    height: 24,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                                style={{ width: 15, height: 15 }}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    this.editQuestion(index)
                                                }}
                                            />
                                            {this.props.localVariables.pollQuestions.value.length > 1 &&
                                                question.value != 'outro' && (
                                                    <Icons
                                                        icon='bin'
                                                        outerStyle={{
                                                            width: 24,
                                                            height: 24,
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        style={{ width: 15, height: 15 }}
                                                        color='#DD4340'
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.deleteQuestion(index)
                                                        }}
                                                    />
                                                )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    <div
                        onClick={(event) => {
                            if (!this.state.dragging) {
                                this.highlightQuestion(event, this.props.localVariables.pollQuestions.value.length - 1)
                            }
                        }}
                        className='mar-b12'
                        style={{
                            width: '100%',
                            border:
                                this.state.selectedQuestion === this.props.localVariables.pollQuestions.value.length - 1
                                    ? '1px solid #15AC98'
                                    : '1px solid #E1E1E0',
                            borderRadius: '8px',
                            padding: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'move'
                        }}
                    >
                        <div className='form-group mar-b0' style={{ flex: '1', fontWeight: '600', fontSize: '13px' }}>
                            {i18n.t('templates:add.drag.polls.outro')}
                        </div>
                        <div style={{ flex: '0 0', display: 'flex', alignItems: 'center' }}>
                            <Icons
                                icon='pencil'
                                color='#0A0A0A'
                                outerStyle={{
                                    width: 24,
                                    height: 24,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                style={{ width: 15, height: 15 }}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    this.editQuestion(this.props.localVariables.pollQuestions.value.length - 1)
                                }}
                            />
                        </div>
                    </div>
                </div>
                {AddQuestionSelect}
            </div>
        )
    }
}
